/* Botón de WhatsApp (sections/pdp-whatsapp.liquid). Reemplaza la app Superlemon, 2026-10-15.
   Arma el mensaje en el momento del clic: producto con la presentación y el precio elegidos,
   el carrito en la página del carrito, o la página que se está viendo.
   Cada clic a un asesor publica el evento de cliente pdp:whatsapp_click (Shopify.analytics),
   sin datos personales. GTM ya no carga en la tienda: lo recoge el píxel personalizado de
   Eventos de cliente (docs/pixel-whatsapp.js), que lo manda a Meta como Contact y a GA4. */
(() => {
  const CALLOUT_KEY = 'pdp-wa-callout';
  const DAY = 24 * 60 * 60 * 1000;

  const calloutSeen = () => {
    try { return Number(localStorage.getItem(CALLOUT_KEY)) || 0; } catch (e) { return 0; }
  };
  const rememberCallout = () => {
    try { localStorage.setItem(CALLOUT_KEY, String(Date.now())); } catch (e) { /* sin almacenamiento */ }
  };

  function init(root) {
    if (!root || root.dataset.waReady) return;
    root.dataset.waReady = 'true';

    const data = JSON.parse(root.querySelector('[data-wa-data]').textContent);
    const toggle = root.querySelector('[data-wa-toggle]');
    const panel = root.querySelector('[data-wa-panel]');
    const callout = root.querySelector('[data-wa-callout]');
    const links = [...root.querySelectorAll('[data-wa-link]')];
    let cartLines = [];

    const pageUrl = () => location.origin + location.pathname;
    /* page_title llega con entidades HTML («&quot;» en la búsqueda). */
    const decode = (text) => Object.assign(document.createElement('textarea'), { innerHTML: text }).value;

    function selectedVariant() {
      const { variants, current } = data.product;
      const inputs = document.querySelectorAll('[data-variant-input], form[action*="/cart/add"] [name="id"]');
      const fromUrl = new URLSearchParams(location.search).get('variant');
      const id = [...inputs].map((input) => input.value).find((value) => variants[value])
        || (variants[fromUrl] ? fromUrl : current);
      return { id, ...variants[id] };
    }

    function message() {
      const lines = data.message ? [data.message, ''] : [];
      if (data.product) {
        const variant = selectedVariant();
        const quantity = Number(document.querySelector('[data-quantity-input]')?.value) || 1;
        lines.push(`*Producto:* ${data.product.title}`);
        if (variant.title) lines.push(`*Presentación:* ${variant.title}`);
        if (quantity > 1) lines.push(`*Cantidad:* ${quantity}`);
        lines.push(`*Precio:* ${variant.price}`, `${pageUrl()}?variant=${variant.id}`);
      } else if (cartLines.length) {
        lines.push('*Mi carrito:*', ...cartLines, pageUrl());
      } else {
        lines.push(`*Estoy viendo:* ${decode(data.pageTitle)}`, pageUrl());
      }
      return lines.join('\n');
    }

    function refresh() {
      const text = encodeURIComponent(message());
      links.forEach((link) => { link.href = `${link.href.split('?')[0]}?text=${text}`; });
    }

    async function loadCart() {
      if (!data.cart) return;
      try {
        const base = window.Shopify?.routes?.root || '/';
        const cart = await (await fetch(`${base}cart.js`, { headers: { Accept: 'application/json' } })).json();
        const money = new Intl.NumberFormat('es-CO', { style: 'currency', currency: cart.currency || data.currency, maximumFractionDigits: 0 });
        const format = (cents) => money.format(cents / 100).replace(/\s/g, '');
        cartLines = cart.item_count
          ? [
            ...cart.items.map((item) => `• ${item.quantity} × ${item.product_title}${item.variant_title ? ` (${item.variant_title})` : ''}`),
            `*Total:* ${format(cart.total_price)}`
          ]
          : [];
      } catch (e) {
        cartLines = [];
      }
      refresh();
    }

    function hideCallout() {
      if (callout) callout.hidden = true;
    }

    function onKey(event) {
      if (event.key === 'Escape') close(true);
    }
    function onOutside(event) {
      if (!root.contains(event.target)) close(false);
    }

    function open() {
      hideCallout();
      refresh();
      loadCart();
      panel.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      links[0]?.focus();
      document.addEventListener('keydown', onKey);
      document.addEventListener('click', onOutside, true);
    }

    function close(returnFocus) {
      if (!panel || panel.hidden) return;
      panel.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      document.removeEventListener('keydown', onKey);
      document.removeEventListener('click', onOutside, true);
      if (returnFocus) toggle.focus();
    }

    toggle?.addEventListener('click', () => (panel.hidden ? open() : close(true)));
    root.querySelector('[data-wa-close]')?.addEventListener('click', () => close(true));
    links.forEach((link) => {
      link.addEventListener('pointerdown', refresh);
      link.addEventListener('focus', refresh);
      link.addEventListener('click', () => {
        window.Shopify?.analytics?.publish?.('pdp:whatsapp_click', {
          whatsapp_agent: link.dataset.waAgent,
          page_type: data.pageType,
          product_id: data.product ? `shopify_${data.product.handle}` : null,
          product_title: data.product ? data.product.title : null
        });
      });
    });

    if (callout) {
      root.querySelector('[data-wa-callout-close]').addEventListener('click', hideCallout);
      root.querySelector('[data-wa-callout-open]').addEventListener('click', () => {
        if (toggle) {
          open();
        } else {
          hideCallout();
          refresh();
          links[0].click();
        }
      });
      if (window.Shopify?.designMode || Date.now() - calloutSeen() > DAY) {
        setTimeout(() => {
          if (panel && !panel.hidden) return;
          callout.hidden = false;
          rememberCallout();
        }, Number(root.dataset.waDelay) * 1000);
      }
    }
  }

  document.querySelectorAll('[data-wa]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-wa]')));
})();
